import React from "react";
import * as priceHelpers from "./../../../bothends/priceHelpers";

import "./priceInput.scss";

interface Props {
  price: IPriceInCurrency;
  onChange: (price: IPriceInCurrency) => void;
}

interface State {
  focussed: boolean;
}

export class PriceInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      focussed: false,
    };
  }

  private onChange = (event) => {
    const newPrice = priceHelpers.round({
      ...this.props.price,
      price: parseFloat(event.target.value),
    });

    this.props.onChange(newPrice);
  }

  private onBlur = () => {
    this.setState({ focussed: false });
  }

  private onFocus = (e) => {
    this.setState({ focussed: true });
    const target = (e.target as HTMLInputElement);
    target.select();
  }

  public render() {
    // Only format the price once the user has stopped inputting their value, or if the input is being put in programmatically.
    const value = this.state.focussed ? this.props.price.price : priceHelpers.toFixed(this.props.price);

    return (
      <div className="price-input-wrapper">
        <div className="price-input-currency">{this.props.price.currency.code}</div>
        <input
          className="price-input"
          type="number"
          onMouseUp={e => e.preventDefault()}
          onFocus={e => this.onFocus(e)}
          onBlur={() => this.onBlur()}
          onChange={this.onChange}
          value={value}
        />
      </div>
    );
  }
}
